import * as React from 'react';
import { Ref, forwardRef } from 'react';
interface SVGRProps {
  color?: string;
  height?: string;
  width?: string;
  title?: string;
  titleId?: string;
}
const SvgGrid = (
  { color = 'currentColor', height = '24px', width = '24px', title, titleId }: SVGRProps,
  ref: Ref<SVGSVGElement>,
): JSX.Element => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    ref={ref}
    aria-labelledby={titleId}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M10 7h4v4h-4V7Zm6 0h4v4h-4V7ZM4 7h4v4H4V7Zm6 6h4v4h-4v-4Zm6 0h4v4h-4v-4ZM4 13h4v4H4v-4Z" fill={color} />
  </svg>
);
const ForwardRef = forwardRef(SvgGrid);
export default ForwardRef;
